import signal from "signals"
import _ from "lodash"

export default class Signal extends signal.Signal {

  constructor(){
    super()
  }
  
  dispatch() {
    console.log(`dispatching`)
    let a = arguments
    _.debounce(() => {
      console.log(`debounced::dispatch`)
      super.dispatch.apply(this, a)
    }, 400)
  }

}



// WEBPACK FOOTER //
// ./src/sdk/Signal.js